<template>
  <div id="landing">
    <NavigationBar />
    <HeroSection />
    <UsageFlowSection />
    <FeaturesSection />
    <TrustSection />
    <VisionSection />
    <FooterSection />
  </div>
</template>

<script>
import NavigationBar from '@/components/Navigation.vue'
import HeroSection from '@/components/HeroSection.vue'
import UsageFlowSection from '@/components/UsageFlowSection.vue'
import FeaturesSection from '@/components/FeaturesSection.vue'
import TrustSection from '@/components/TrustSection.vue'
import VisionSection from '@/components/VisionSection.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'LandingPage',
  components: {
    NavigationBar,
    HeroSection,
    UsageFlowSection,
    FeaturesSection,
    TrustSection,
    VisionSection,
    FooterSection
  }
}
</script>

<style scoped>
#landing {
  width: 100%;
}
</style>
